import React, { useState, useRef, useEffect } from 'react';
import { Container } from './styles'

export const Fade = ({ isShow, children, onHidden, zIndex, isFull, isTransitionMode }) => {
    const [transition, setTransition] = useState(false);
    const [visible, setVisible] = useState(isShow);
    const transitionDuration = 150;
    const refTimer = useRef();
    useEffect(() => {
        if (isShow !== visible) {
            setTransition(true);
        }
    }, [isShow, visible, transition]);

    useEffect(() => {
        if (!transition) return;
        setVisible(isShow);
        clearTimeout(refTimer.current);
        refTimer.current = setTimeout(() => setTransition(false), transitionDuration);
        return () => clearTimeout(refTimer.current);
    }, [transition]);

    useEffect(() => {
        if (!visible && !transition && onHidden) {
            onHidden();
        }
    }, [visible, transition]);

    useEffect(() => {
        setVisible(isShow);
    }, [isShow]);

    return visible || transition ? <Container  isVisible={visible} zIndex={zIndex} className={[visible ?  isTransitionMode ? 'fade-in' : 'is-visible' : 'fade-out', isFull ? 'full-page' : undefined].join(' ')} transitionDuration={transitionDuration}>{children}</Container> : null;
}
